<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="user_official_factor_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('reports.users.select_date_interval') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#user_official_factor_filter">
                    <div class="card-body">
                        <form id="official_factor_form" @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="month">
                                                {{ $t('reports.users.month') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="month"
                                                    class="form-control"
                                                    name="month"
                                                    v-model="query.month"
                                            >
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(month, index) in persianMonths"
                                                        v-bind:value="month.value"
                                                        :selected="query.month === month.value"
                                                >
                                                    {{ month.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="year">
                                                {{ $t('reports.users.year') }}
                                            </kt-form-label>
                                            <select
                                                    id="year"
                                                    class="form-control kt-selectpicker"
                                                    name="year"
                                                    v-model="query.year"
                                            >
                                                <option
                                                        v-bind:key="year"
                                                        v-for="year in years"
                                                        v-bind:value="year"
                                                        :selected="query.year === year"
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <button class="btn btn-success btn-wide" @submit="action($event, query)">
                                            {{ $t('label.filter') }}
                                        </button>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <button
                                                class="btn btn-success btn-wide float-right"
                                                size="md"
                                                type="button"
                                                id="export_btn"
                                                @click="actionAllUsers($event, query)"
                                        >
                                            {{ $t('reports.btn.all_users_factors') }}
                                        </button>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

    import $ from "jquery";
    import { i18n } from '@/plugins/i18n'
    import { persianMonths } from '@/constants/date'

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            actionAllUsers: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                query: {},
                years: [''],
                persianMonths : persianMonths
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            },
            getYear() {
                let year = new Date().getFullYear() - 620;
                for (let $i = 0; $i < 12 ; $i++) {
                    this.years.push(year - $i)
                }
            },
        },
        mounted() {
            this.getYear()
            this.afterDispatch()
        },
    }
</script>

<style>

</style>